import { TextInput } from 'jl-design-system/components/text-input/TextInput';
import { Select } from 'jl-design-system/components/select/Select';

import { ConnectedPhoneNumberInfo as PhoneNumberInfo } from './PhoneNumberInfo';

const addSessionCamExcludeClassName = (field) => [field.className, 'sessioncamexclude'].join(' ');

// Local field configurations (migrated from jl-design-system/form/fields)
const TITLE_BASE = {
  name: 'title',
  type: 'SELECT',
  label: 'Title',
  required: true,
  options: [
    { value: '', text: 'Please select' },
    { value: 'Mr', text: 'Mr' },
    { value: 'Mrs', text: 'Mrs' },
    { value: 'Miss', text: 'Miss' },
    { value: 'Ms', text: 'Ms' },
    { value: 'Mx', text: 'Mx' },
    { value: 'Dr', text: 'Dr' },
  ],
  validationMessageKeys: {
    required: 'Please select a title',
  },
};

const FIRST_NAME_BASE = {
  name: 'firstName',
  type: 'TEXT',
  label: 'First name',
  required: true,
  maxLength: 32,
  className: '',
  validationMessageKeys: {
    required: 'This field is required',
    maxLength: 'First name is too long',
  },
};

const LAST_NAME_BASE = {
  name: 'lastName',
  type: 'TEXT',
  label: 'Last name',
  required: true,
  maxLength: 32,
  className: '',
  validationMessageKeys: {
    required: 'This field is required',
    maxLength: 'Last name is too long',
  },
};

const PHONE_NUMBER_BASE = {
  name: 'phoneNumber',
  type: 'TEL',
  label: 'Phone number',
  required: true,
  maxLength: 20,
  className: '',
  validationMessageKeys: {
    required: 'This field is required',
    regex: 'Please enter a valid phone number',
    invalid: 'Please enter a valid phone number',
    maxLength: 'Phone number is too long',
  },
};

const PHONE_NUMBER_UK_MOBILE_BASE = {
  name: 'phoneNumber',
  type: 'TEL',
  label: 'Mobile number',
  required: true,
  maxLength: 20,
  className: '',
  validationMessageKeys: {
    required: 'This field is required',
    regex: 'Please enter a valid UK mobile number',
  },
};

const PHONE_NUMBER_ALTERNATIVE_BASE = {
  name: 'phoneNumberAlternative',
  type: 'TEL',
  label: 'Alternative phone number (optional)',
  required: false,
  maxLength: 20,
  className: '',
  validationMessageKeys: {
    regex: 'Please enter a valid phone number',
    invalid: 'Please enter a valid phone number',
    maxLength: 'Phone number is too long',
  },
};

const phoneNumberValidationMessageKeys = {
  ...PHONE_NUMBER_BASE.validationMessageKeys,
  required: 'Please enter a UK phone number',
  regex: 'Please enter a valid UK mobile or landline number',
  invalid: 'Please enter a valid UK mobile or landline number',
  maxLength: 'Please enter a valid UK mobile or landline number',
};

const phoneNumberRegex = /^0([1238][0-9]{7,9})$|^0(7\d{9})$|^\+44\s?7\d{9}$/;

export const YOUR_DETAILS_FIELDS = [
  {
    ...FIRST_NAME_BASE,
    component: TextInput,
    className: addSessionCamExcludeClassName(FIRST_NAME_BASE),
    validationMessageKeys: {
      ...FIRST_NAME_BASE.validationMessageKeys,
      required: 'Please enter your first name',
    },
    normalize: (val) => (val ? val.slice(0, FIRST_NAME_BASE.maxLength) : val),
  },
  {
    ...LAST_NAME_BASE,
    component: TextInput,
    maxLength: 31,
    className: addSessionCamExcludeClassName(LAST_NAME_BASE),
    validationMessageKeys: {
      ...LAST_NAME_BASE.validationMessageKeys,
      required: 'Please enter your last name',
    },
    normalize: (val) => (val ? val.slice(0, LAST_NAME_BASE.maxLength) : val),
  },
  {
    ...PHONE_NUMBER_BASE,
    label: 'Phone number',
    component: TextInput,
    regex: phoneNumberRegex,
    extra: <PhoneNumberInfo />,
    className: addSessionCamExcludeClassName(PHONE_NUMBER_BASE),
    validationMessageKeys: phoneNumberValidationMessageKeys,
    supportingText: "We'll send you a text to confirm your booking.",
  },
];

export const MOBILE_PHONE_NUMBER = {
  ...PHONE_NUMBER_UK_MOBILE_BASE,
  className: addSessionCamExcludeClassName(PHONE_NUMBER_UK_MOBILE_BASE),
};

export const PHONE_NUMBER_ALTERNATIVE = {
  ...PHONE_NUMBER_ALTERNATIVE_BASE,
  regex: phoneNumberRegex,
  className: addSessionCamExcludeClassName(PHONE_NUMBER_ALTERNATIVE_BASE),
  validationMessageKeys: phoneNumberValidationMessageKeys,
};

export const TITLE = {
  ...TITLE_BASE,
  component: Select,
  className: addSessionCamExcludeClassName(TITLE_BASE),
};
